import actionCreatorFactory from 'typescript-fsa';
import { sendEventMessage, Message } from '../utils/native';
import { getSelectedForms } from '../utils/formSet';

import * as store from './store';

const actionCreator = actionCreatorFactory();

export const setFormField = actionCreator<{
  formFieldId: string;
  value: string;
}>('SET_FORM_FIELD');
export function setFormFieldHandler(
  state: store.All,
  args: { formFieldId: string; value: string },
): store.All {
  sendEventMessage(Message.ActiveAction);
  const { selectedFormId, selectedFormSetId } = state;
  if (!selectedFormId || !selectedFormSetId) {
    console.warn('selectedFormId or selectedFormSetId is not defined');
    return state;
  }
  const { formFieldId, value } = args;
  const form = getSelectedForms(state.formSets, selectedFormSetId)[
    selectedFormId
  ];
  // NOTE: due to the way edited questions are tracked, the updated date needs to be manually set
  form.fields = form.fields.map((f) =>
    f.id === formFieldId
      ? { ...f, value, updated: new Date().toISOString() }
      : f,
  );
  return {
    ...state,
    formSets: {
      ...state.formSets,
      [selectedFormSetId]: {
        ...state.formSets[selectedFormSetId],
        forms: {
          ...state.formSets[selectedFormSetId].forms,
          [selectedFormId]: form,
        },
      },
    },
  };
}
